import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';

export const languages = ['EN', 'UK', 'VI'] as const;

const backendOptions: Record<'backend', HttpBackendOptions> = {
  backend: {
    loadPath: '/translations/{{lng}}/{{ns}}.json',
    requestOptions: { cache: 'no-cache' },
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    defaultNS: 'translation',
    detection: {
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => lng?.split('-')[0],
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
    fallbackLng: 'EN',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    supportedLngs: [...languages],

    ...backendOptions,
  });

export default i18n;
